export default __webpack_public_path__ + "static/media/pause-circle.5e99ce25.svg";